import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import {
    Label,
    LabelProps
} from 'UI-Dash-Commons-UI';

export enum DocsPageHeaderType
{
    HEADING_1,
    HEADING_2,
    HEADING_3,
    HEADING_4,
    HEADING_5,
}

interface PageHeaderProps extends LabelProps
{
    text: string,
    type?: DocsPageHeaderType,
    isLink?: boolean,
}

const DocsPageHeaderComponent: FunctionComponent<PageHeaderProps> = ({ text, type = DocsPageHeaderType.HEADING_1, isLink, ...rest }) =>
{
    const isDocsPageHeaderLinkable = ( isLink || type === DocsPageHeaderType.HEADING_1 || type === DocsPageHeaderType.HEADING_2 || type === DocsPageHeaderType.HEADING_3 ) && text;
    const DocsPageHeaderLinkStr = isDocsPageHeaderLinkable ? text.toLowerCase().split(' ').join('-') : '';
    const DocsPageHeaderLinkImg = require( '../../modules/MediationDocs/images/link.svg' );

    return <DocsPageHeaderWrapper>
        {
            isDocsPageHeaderLinkable &&
            <DocsPageHeaderLinkWrapper>
                <DocsPageHeaderLink id={`link-${DocsPageHeaderLinkStr}`} href={`#${DocsPageHeaderLinkStr}`}>
                    <DocsPageHeaderLinkImage src={DocsPageHeaderLinkImg} alt={'header-link'} type={type}/>
                </DocsPageHeaderLink>
                <DocsPageHeaderLinkTarget id={DocsPageHeaderLinkStr}/>
            </DocsPageHeaderLinkWrapper>
        }
        <DocsPageHeader text={text} type={type} {...rest}/>
    </DocsPageHeaderWrapper>;
};

export default DocsPageHeaderComponent;

const DocsPageHeaderWrapper = styled.div`
  position: relative;
`;

const DocsPageHeaderLinkWrapper = styled.div`
`;

const DocsPageHeaderLink = styled( 'a' )`
`;

const DocsPageHeaderLinkImage = styled.img<{ type: DocsPageHeaderType }>`
  max-width: 20px;
  height: auto;

  position: absolute;
  margin-top: 1px;
  margin-top: ${props => props.type === DocsPageHeaderType.HEADING_2 && '5px' };
  margin-left: -25px;
  padding-right: 5px;

  opacity: 0;
  &:hover {
    opacity: 1;
  }

  ${DocsPageHeaderWrapper}:hover & {
    opacity: 1;
  }
`;

const DocsPageHeaderLinkTarget = styled.a`
  display: block;
  position: relative;
  top: -115px;
  visibility: hidden;
`;

const DocsPageHeader = styled( Label )<{ type: DocsPageHeaderType }>`
  display: block;
  margin: 20px 0px;

  margin-top: ${props => props.type === DocsPageHeaderType.HEADING_1 && '0px' };
  margin-top: ${props => props.type === DocsPageHeaderType.HEADING_2 && '45px' };
  margin-top: ${props => props.type === DocsPageHeaderType.HEADING_3 && '35px' };

  font-family: ${props => props.theme.fonts.demi};
  font-family: ${props => props.type === DocsPageHeaderType.HEADING_1 && props.theme.fonts.demi};
  font-family: ${props => props.type === DocsPageHeaderType.HEADING_2 && props.theme.fonts.regular };
  font-family: ${props => props.type === DocsPageHeaderType.HEADING_3 && props.theme.fonts.medium };
  font-family: ${props => props.type === DocsPageHeaderType.HEADING_4 && props.theme.fonts.regular };
  font-family: ${props => props.type === DocsPageHeaderType.HEADING_5 && props.theme.fonts.regular };

  font-size: 22px;
  font-size: ${props => props.type === DocsPageHeaderType.HEADING_1 && '28px' };
  font-size: ${props => props.type === DocsPageHeaderType.HEADING_2 && '26px' };
  font-size: ${props => props.type === DocsPageHeaderType.HEADING_3 && '20px' };
  font-size: ${props => props.type === DocsPageHeaderType.HEADING_4 && '18px' };
  font-size: ${props => props.type === DocsPageHeaderType.HEADING_5 && '16px' };
  

  color: ${props => props.theme.colors.blackLight};
  color: ${props => props.type === DocsPageHeaderType.HEADING_4 && props.theme.colors.tertiaryText };
  color: ${props => props.type === DocsPageHeaderType.HEADING_5 && props.theme.colors.tertiaryText };

`;
